/**
 * Admin/GetUserAccounts Controller
 *
 * 
 */

// the constructor for this object
function AdminGetUserAccountsController() { }

// the object
AdminGetUserAccountsController.prototype = {
    constructor: AdminGetUserAccountsController,
    
    // the user id to get accounts from
    userId: null,
    
    // where to redirect when accounts have been changed
    redirectUrl: null,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // the user must be a USS admin to access this page
        PortalMain.ussAdminRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        PortalHelper.debugMessage('Admin Get User Accounts Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        // fill in the url to redirect
        this._buildRedirectUrl();
        
        // get the user to get accounts from
        this._getUser();
        
        PortalHelper.debugMessage('Admin Get User Accounts Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the variables
        if (segments.length == 1) {
            this.userId = segments[0];
            this.redirectUrl = PortalHelper.getUrlParameter('url');
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        $('#get-user-accounts-button').on('click', function(){
            PortalMain.AdminGetUserAccountsController._getUserAccounts();
        });
    },
    
    // build the redire
    _buildRedirectUrl: function()
    {
        // set up the redirect url
        var newUrl = PortalConfig.portalUrl;
        newUrl += decodeURIComponent(this.redirectUrl);
        this.redirectUrl = newUrl;
        
        // slap this into the template
        $('#redirect-url').html(this.redirectUrl);
    },
    
    // get the user
    _getUser: function()
    {
        // make the request
        var accessRequest = new PortalRequest;
        accessRequest.makeRequest(
            '/admin/get-user',
            {
                userId: PortalMain.AdminGetUserAccountsController.userId
            },
            function(user) {
                PortalMain.AdminGetUserAccountsController._populateUser(user);
            }
        );
    },

    // populate details of the user to get accounts from
    _populateUser: function(user)
    {
        $('#user-email').html(user.email_nm);
    },
    
    // clear the account access for the authenticated user
    _getUserAccounts: function()
    {
        // make the request
        var accessRequest = new PortalRequest;
        accessRequest.makeRequest(
            '/admin/get-user-accounts',
            {
                userId: PortalMain.AdminGetUserAccountsController.userId
            },
            function() {
                PortalMain.PortalLogin.forceLoginUpdateOnNextLoad();
                
                window.location = PortalMain.AdminGetUserAccountsController.redirectUrl;
            }
        );
    },

}